import { useEffect, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import useLanguage from "../hooks/useLanguage";
import useStyles from "../styles/pages/PolicyStyles";
import PrivacyData from "../data/policy";

function Policy(props) {
  const classes = useStyles(props);
  const history = useHistory();
  const { key } = useParams();

  const { key: languageKey, routeKey } = useLanguage();

  const item = useMemo(() => {
    const list = Array.isArray(PrivacyData) ? PrivacyData : [];
    if (!key) return list[0] ?? null;
    return list.find((x) => String(x?.key) === String(key)) ?? null;
  }, [key]);

  useEffect(() => {
    if (!item) {
      const base = routeKey ? `/${routeKey}` : "";
      history.replace(`${base}/policy`);
    }
  }, [item, history, routeKey]);

  const html = item?.content?.[languageKey] ?? "";

  return (
    <Grid
      item
      container
      xs={11}
      md={11}
      className={classes.contentContainerGrid}
    >
      <Grid item xs={12}>
        <div
          className={classes.policy}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </Grid>
    </Grid>
  );
}

export default Policy;
